import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9a4c1ac0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "nft",
  class: "modal-window modal-window-squade"
}
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Choose soldier", -1))
const _hoisted_4 = { class: "row modal-cards" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_choose_bear_item = _resolveComponent("choose-bear-item")!
  const _component_Load = _resolveComponent("Load")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('closeModal'))),
        class: "modal-close"
      }, " × "),
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allowedTokens, (tokenId) => {
          return (_openBlock(), _createBlock(_component_choose_bear_item, {
            key: tokenId,
            img: _ctx.userTokensData[tokenId].metadata.image,
            name: _ctx.userTokensData[tokenId].metadata.name,
            tokenId: _ctx.userTokensData[tokenId].tokenId,
            onClickToken: _cache[1] || (_cache[1] = ($event: any) => (_ctx.parameterPassing($event)))
          }, null, 8, ["img", "name", "tokenId"]))
        }), 128)),
        (_ctx.userTokensData == undefined)
          ? (_openBlock(), _createBlock(_component_Load, { key: 0 }))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}